<template>
  <div>
    <el-dialog v-bind="$attrs" v-on="$listeners" @open="onOpen" @close="onClose" :title="dialogTitle" width="1100px">
      <div v-loading="loading"
           element-loading-text="加载中"
           element-loading-spinner="el-icon-loading">
        <el-form :model="billForm" class="billForm" ref="elForm" label-width="100px"
                 style="text-align:left;padding:0 10px;overflow:auto" size="mini">
          <div class="bill-border">
            <template>
              <div>
                <div style="margin-bottom: 10px"><b>基础信息</b></div>
                <el-row>
                  <el-col :span="12">
                    <el-row>
                      <el-col :span="10">
                        <el-form-item label="申请人：">{{ billForm.applicant }}</el-form-item>
                      </el-col>
                      <el-col :span="14" v-if="billForm.status==='pass'">
                        <el-form-item label="发票号码：">
                          <div v-if="!editInvoice">
                            <span class="c-red invoice-number">{{ billForm.invoice_number || '--' }}</span>
                            <el-button type="text" icon="el-icon-edit" v-if="userAuth.can_audit_invoice"
                                       @click="editInvoice=true"></el-button>
                          </div>
                          <div v-else>
                            <el-input v-model="billForm.invoice_number" maxlength="20" placeholder="发票号码"
                                      show-word-limit clearable>
                              <template slot="append">
                                <el-button @click="saveInvoiceNumber()">
                                  <i style="color: #ff3176!important;" class="el-icon-check"></i>
                                </el-button>
                              </template>
                            </el-input>
                          </div>

                        </el-form-item>
                      </el-col>
                    </el-row>

                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="乙方：">{{ billForm.party_b_name }}</el-form-item>
                  </el-col>

                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="发票类型：">{{ billForm.type | statusFilter }}</el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="发票抬头：">{{ billForm.invoice_title }}</el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="发票金额：">{{ moneyFormat(billForm.amount_money) }}</el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="审核金额：">
                      <div v-if="editMode!=='check_money'">
                        <span class="check-money"> {{ moneyFormat(billForm.check_money || '--') }}</span>
                        <el-button type="text" v-if="userAuth.can_audit_invoice&&billForm.status==='wait'"
                                   @click="editMode='check_money'" icon="el-icon-edit"></el-button>
                      </div>
                      <div v-else-if="editMode==='check_money'">
                        <el-input v-model="billForm.check_money" :disabled="!editMode" placeholder="输入审核金额">
                          <template slot="append" v-if="billForm.status==='wait'">
                            <el-button @click="saveCheckMoney"
                                       style="color: #ff3176!important;font-size: 1.2em;font-weight: bold"
                                       icon="el-icon-check">
                            </el-button>
                          </template>
                        </el-input>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="税号：">{{ billForm.tax_id }}</el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="发票内容：">
                      {{ billForm.content }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="电子邮箱：">{{ billForm.contact_email || '-' }}</el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="发票备注栏：">
                      {{ billForm.remark || '--' }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="财务备注：">
                      <div v-if="editMode!=='remark_financial'">
                        <span style="width: 210px">{{ billForm.remark_financial || '--' }}</span>
                        &nbsp;
                        <el-button type="text" v-if="userAuth.can_audit_invoice" @click="editMode='remark_financial'"
                                   icon="el-icon-edit"/>
                      </div>
                      <div v-else-if="editMode==='remark_financial'">
                        <el-input v-model="billForm.remark_financial" placeholder="输入财务备注" maxlength="100"
                                  show-word-limit>
                          <template slot="append">
                            <el-button @click="saveRemarkFinancial"
                                       style="color: #ff3176!important;font-size: 1.2em;font-weight: bold"
                                       icon="el-icon-check">
                            </el-button>
                            <el-button @click="handleDefaultFinancial"
                                       style="color: #ff3176!important;font-size: 1.2em;font-weight: bold"
                                       title="点击，将自动填充财务备注内容。财务备注:开票来源&红人&品牌&店铺&平台&开票区间"
                                       icon="el-icon-circle-check">
                            </el-button>
                          </template>
                        </el-input>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <!--              <div>-->
              <!--                <div style="margin-bottom: 10px"><b>接收方式</b></div>-->
              <!--                <el-row>-->
              <!--                  <el-col :span="8">-->
              <!--                    <el-form-item label="电子邮箱：">{{ billForm.contact_email || '-' }}</el-form-item>-->
              <!--                  </el-col>-->
              <!--                </el-row>-->
              <!--              </div>-->
              <div v-if="billForm.commission_rel">
                <div style="margin-bottom: 10px"><b>关联信息</b></div>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="开票来源：">
                      {{ billForm.commission_rel.invoice_source_alias || billForm.commission_rel.invoice_source }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="红人：" v-if="billForm.commission_rel.kol_nicknames">{{ billForm.commission_rel.kol_nicknames.join('、') }}</el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="品牌：">{{ billForm.commission_rel.brand }}</el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="店铺：">{{ billForm.commission_rel.store }}</el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="平台：" v-if="billForm.commission_rel.platform">{{ billForm.commission_rel.platform.join('、') }}</el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="开票区间：">
                      {{ dateFmt(billForm.commission_rel.invoice_period_start) }}
                      ~
                      {{ dateFmt(billForm.commission_rel.invoice_period_end) }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="附件：">
                      <div v-if="billForm.commission_rel.attachment_id && billForm.commission_rel.attachment">
                        <span>{{ billForm.commission_rel.attachment.title }}
                          <el-link style="font-size: 20px;margin-left: 10px;color: #ff3176"  @click="handleDownload(billForm.commission_rel.attachment)" icon="el-icon-download"
                            title="下载"></el-link></span>
                        <div v-if="billForm.commission_rel.attachment.mime_type.indexOf('image')>-1">
                          <el-image
                              style="width: 100px; height: 100px"
                              v-if="billForm.commission_rel.attachment.url"
                              :src="billForm.commission_rel.attachment.url"
                              :preview-src-list="[billForm.commission_rel.attachment.url]">
                          </el-image>
                        </div>

                      </div>
                      <div v-else>
                        未附件上传
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </template>
          </div>
          <el-row v-if="billForm.status === 'reject'">
            <el-col :span="12">
              <el-form-item label="不通过原因：">{{ billForm.unpass_reason }}</el-form-item>
            </el-col>
          </el-row>
          <div style="text-align:center;" v-if="userAuth.can_audit_invoice">
            <div v-if="billForm.status === 'wait'">
              <el-button :disabled="loadingCommit" :loading="loadingCommit" type="primary" class="el-button--operation"
                         @click="pass" size="mini"
                         style="margin-right:30px;width: 100px">通过
              </el-button>
              <el-button type="info" @click="reject" style="width: 100px" size="mini">拒绝
              </el-button>
            </div>
          </div>
          <div v-if="billForm.status==='pass'&&userAuth.reset_audit_invoice">
            <el-button :disabled="loadingCommit" :loading="loadingCommit" type="warning" @click="resetPass" size="mini"
                       style="margin-right:30px;width: 100px;float: right">重新审核
            </el-button>
          </div>
        </el-form>
      </div>
      <el-dialog title="拒绝理由" :visible.sync="dialogReject" class="reject-dialog" append-to-body>
        <el-form class="billForm" :model="rejectForm" :rules="rules" ref="rejectForm" label-width="100px"
                 style="text-align:left;padding:0 120px;">
          <el-row>
            <el-col :span="24">
              <el-form-item label="原因：" prop="unpass_reason">
                <el-input type="textarea" :row="6" v-model="rejectForm.unpass_reason"
                          placeholder="请输入不通过原因"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <div style="text-align:center;">
            <button-submit button-txt="确定" type="primary" @click.native.prevent="rejectSubmit"
                           style="margin-right:30px;width: 100px"/>
            <el-button type="info" @click="cancel" style="width: 100px">取消</el-button>
          </div>
        </el-form>
      </el-dialog>

    </el-dialog>
  </div>
</template>

<script>
import {
  getBillDetail,
  resetBillStatus,
  saveInvoiceCheckMoney,
  saveInvoiceNumber,
  setBillStatus,
  saveRemarkFinancial
} from "@/api/bill";
import {parseTime} from "@/utils";
import {downLoadFile} from "@/utils/upload";

export default {
  name: "BillDetailDialog",
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
    dialogTitle() {
      return `发票详情 - ${this.billForm.customer_name}`
    },
    preImageUrl() {
      return this.billForm.commission_rel.attachment.url || ''
    }
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        'spe_invoice': '电子专票',
        'common_invoice': '电子普票',
      }
      return statusMap[status]
    },
  },
  props: {
    id: {
      type: [Number, String],
      default() {
        return null
      }
    }
  },
  data() {
    return {
      statusMap: {
        'wait': {
          text: '待审核',
          color: '#FFA933'
        },
        'pass': {
          text: '已通过',
          color: '#39BA85'
        },
        'reject': {
          text: '已拒绝',
          color: '#FE5B83'
        }
      },
      loading: false,
      billForm: {
        remark_financial: null//财务备注
      },
      editMode: false,
      editInvoice: false,//修改发票号
      dialogReject: false,
      rejectForm: {
        unpass_reason: '' // reject reason
      },
      rules: {
        unpass_reason: {required: true, message: '请输入拒绝原因', trigger: 'blur'}
      },
      loadingCommit: false,
    }
  },
  methods: {
    async onOpen() {
      this.editMode = false
      this.editInvoice = false //修改发票号
      this.loadingCommit = false;
      await this.getDetail()
      this.autoSaveCheckMoney()
    },
    onClose() {
      this.$refs['elForm'].resetFields()
      this.$emit('closed')
    },
    close() {
      this.$emit('update:visible', false)
    },
    moneyFormat(val) {
      return this.gFunc.numberFormat(val, 2, '.', ',')
    },
    getDetail: async function () {
      this.billForm = {}
      if (!this.id) {
        this.$message.error('操作异常！')
        return;
      }
      this.loading = true
      const res = await getBillDetail(this.id)
      this.billForm = res.model || {}
      this.loading = false
    },
    /**
     * ① 待审核
     * ② 有权限
     * ③ 没有填充过审核金额
     */
    autoSaveCheckMoney: function () {
      this.loading = true
      this.$nextTick(async () => {
        if (this.billForm.status === 'wait' && this.userAuth.can_audit_invoice && !this.billForm.check_money) {
          // 待审核&&有权限&&没有填充过审核金额
          // 自动填充审核金额
          this.billForm.id = this.id
          this.billForm.check_money = this.billForm.amount_money
          await this.saveCheckMoney()
        }
        this.loading = false
      })
    },
    saveCheckMoney: async function () {
      let checkForm = {id: this.billForm.id, check_money: this.billForm.check_money}

      await saveInvoiceCheckMoney(checkForm).then(res => {
        if (res.success) {
          this.getDetail()
          this.editMode = false
        } else {
          this.$notify.warning('保存失败')
        }
      })
    },
    //保存发票号码
    saveInvoiceNumber() {
      let postData = {id: this.billForm.id, invoice_number: this.billForm.invoice_number}

      saveInvoiceNumber(postData).then(res => {
        if (res.success) {
          this.$notify.success('保存成功')
          this.editInvoice = false
        } else {
          this.$notify.warning('保存失败')
        }
      })
    },
    async saveRemarkFinancial() {
      const that = this;
      const response = await saveRemarkFinancial({id: this.id, remark_financial: this.billForm.remark_financial});
      if (!response.success) {
        this.showToast({h: that, icon: "el-icon-error", text: response.message, duration: 3000});
        return;
      }
      this.getDetail();
      this.showToast({h: that, icon: "el-icon-success", text: '操作成功', duration: 2000});
      this.editMode = false
    },
    handleDefaultFinancial() {
      //开票来源&红人&品牌&店铺&平台&开票区间
      //billForm.commission_rel.invoice_source_alias
      const strArr = [
        `${this.billForm.commission_rel.invoice_source_alias}`,
        `${this.billForm.commission_rel.kol_nicknames.join('、')}`,
        `${this.billForm.commission_rel.brand}`,
        `${this.billForm.commission_rel.store}`,
        `${this.billForm.commission_rel.platform.join('、')}`,
        `${this.dateFmt(this.billForm.commission_rel.invoice_period_start)}~${this.dateFmt(this.billForm.commission_rel.invoice_period_end)}`
      ];
      this.billForm.remark_financial = strArr.join(' ')
    },
    //通过申请
    async pass() {
      const that = this;
      this.loadingCommit = true;
      const response = await setBillStatus({id: this.id, status: 'pass'});
      this.loadingCommit = false;
      if (!response.success) {
        this.showToast({h: that, icon: "el-icon-error", text: response.message, duration: 3000});
        return;
      }
      this.showToast({h: that, icon: "el-icon-success", text: '操作成功', duration: 2000});
      this.close()
    },
    //重新审核
    resetPass() {
      this.loadingCommit = true;
      this.$msgbox.confirm('此操作将重置已审核通过的开票状态为“待审核”, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        resetBillStatus({id: this.id}).then(res => {
          this.loadingCommit = false;
          if (res.success) {
            this.$notify.success('重置成功，请到【待审核】重新审核！！！')
            this.showToast({h: this})
            this.close()
          }
        })
      }).catch(() => {
        this.loadingCommit = false;
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });

    },
    //拒绝申请
    reject() {
      this.dialogReject = true
    },
    rejectSubmit() {
      let that = this
      that.$refs['rejectForm'].validateField('unpass_reason', async (res) => {
        if (res) {
          return false
        } else {
          let postData = {
            id: this.id,
            status: 'reject',
            unpass_reason: this.rejectForm.unpass_reason
          }

          const that = this
          const response = await setBillStatus(postData);
          this.loadingCommit = false;
          if (!response.success) {
            this.showToast({h: that, icon: "el-icon-error", text: response.message, duration: 3000});
            return;
          }
          this.showToast({h: that, icon: "el-icon-success", text: '操作成功', duration: 2000});
          this.dialogReject = false;
          this.onClose()
        }
      })
    },
    cancel() {
      this.dialogReject = false
    },
    saveInvoiceNo() {
      this.$notify.warning('开发中...')
    },
    dateFmt(dateStr) {
      if (dateStr)
        return parseTime(dateStr, '{y}-{m}-{d}')

      return ''
    },
    handleDownload(fileObj) {

      // this.FileSaver.saveAs(fileObj.url, fileObj.title);
      downLoadFile(fileObj.id, fileObj.title, () => {
        this.msgSuccess('下载成功')
      })
    }
  }
}
</script>

<style scoped>
.invoice-number {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 1.2em;
  padding-left: 10px;
  padding-right: 10px;
}

/*.invoice-number::before {*/
/*  content: '№';*/
/*  font-size: 1.2em;*/
/*  margin-right: 10px;*/
/*}*/

.c-red {
  color: #ff3133;
}

.check-money {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 1.2em;
  padding-left: 10px;
  padding-right: 10px;
}
</style>
